import * as $ from 'jquery';
import {safeLocalStorage} from './utils/safeLocalStorage.js';
import * as Ajax from './utils/ajax';
import { hideCookiesBanner } from './utils/cookies';
import { onLoad } from './utils/onLoad';
import {hideFullPageLoader} from './loaders.js';
import {setBannerCloseButton, removeAlertOnLinkClick} from './banners.js';

const config = JSON.parse(document.getElementById('js-config').innerHTML),
    mobileBreakPoint = 991;
const TYPINGDELAY = 200;

/* Utilidad para mostrar un alert con html dinamico. Pep a ver donde me pones esto */
function defaultAlertModal(html, singleModal = false) {
    const bodyElement = document.querySelector("body");
    if (singleModal){
        if (bodyElement.classList.contains("modal-open")) {
            return;
        }
    }
    $('.modal').each(function(){
        $(this).modal('hide');
    });
    $('#default-modal .modal-body').html(html);
    $('#default-modal .modal-footer .button').addClass('d-none');
    $('#default-modal .modal-footer .js-for-alert').removeClass('d-none');
    $('#default-modal').modal('show');
}

let onDialogConfirm = null, onDialogCancel = null;

$(document).on('click', '[id$="-modal"] .js-dialog-success', function(){
    if(onDialogConfirm){
        onDialogConfirm();
        $('#default-modal').modal('hide');
    }
});

$(document).on('hidden.bs.modal', '[id$="-modal"]', function(){
    if(onDialogCancel){
        onDialogCancel();
    }
    onDialogConfirm = onDialogCancel = null;
});

function defaultConfirmModal(html, onConfirm, onCancel, template = '#default-modal'){
    $('.modal').each(function(){
        $(this).modal('hide');
    });
    onDialogConfirm = onConfirm;
    onDialogCancel = onCancel;
    $(template + ' .modal-body').html(html);
    $(template + ' .modal-footer .button').removeClass('d-none');
    $(template + ' .modal-footer .js-for-alert').addClass('d-none');
    $(template).modal('show');
}

//Borrar producto
$('#modal-delete-product').on('show.bs.modal', e =>{
    const productId = $(e.relatedTarget)[0].value;
    $('#modal-delete-product').find('.js-delete-product-button')[0].value = productId
});
document.querySelectorAll('.js-delete-product-button').forEach(async button => {
    button.addEventListener('click', async e => {
        const productId = button.value ?? e.relatedTarget.value;
        await Ajax.del(`/api/v5/products/${productId}`, {}, false);
        window.location.href = '/profile';
    });
});

$(document).on('click', '.js-modal-password-recovery', function(e){
    e.preventDefault();
    $('.modal').each(function(){
        $(this).modal('hide');
    });
    $('#modal-password-recovery').modal('show');
});

document.addEventListener('submit', e => {
    if (e.target && e.submitter) {
        const btn = e.submitter;
        if (btn && btn.classList.contains('btn-loading')) {
            btnLoading(btn);
        }
    }
});

function btnLoading(submitBtn, active = true)
{
    const btn = $(submitBtn)[0] ? $(submitBtn)[0] : submitBtn,
        text =  btn.querySelector('.js-btn-text'),
        spinner = btn.querySelector('.js-btn-loading');
    if (text && spinner) {
        if (active) {
            text.innerText = btn.dataset.loadingText;
            spinner.classList.remove('d-none');
        } else {
            text.innerHTML = btn.dataset.originalText;
            spinner.classList.add('d-none');
        }
    }
}

const debounce = (func, delay) => {
  let debounceTimer;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};

$(document).on('change', '.form-control.is-invalid', function(e){
    $(this).removeClass('is-invalid');
});

$('.form-control').on('invalid', function(){
    $(this).addClass('is-invalid');
});

function canCallApp(funcName){
    return typeof Trendier === "object" && typeof Trendier[funcName] === 'function';
}

function inArray(needle, haystack) {
    var length = haystack.length;
    for(var i = 0; i < length; i++) {
        if(typeof haystack[i] == 'object') {
            if(arrayCompare(haystack[i], needle)) return true;
        } else {
            if(haystack[i] == needle) return true;
        }
    }
    return false;
}

if (canCallApp('openURL'))
{
    $(document).on('click', 'a[href]', function(e){
        if ($(this).data('callApp')) return;
        var url = $(this).attr('href'),
            m = url?.indexOf('http');
        if (m == 0 && ($(this).attr('target') == '_blank' || $(this).hasClass('app_external_link'))) {
            e.preventDefault();
            Trendier.openURL(url);
        }
    });
}

$(document).on('show.bs.modal', '.modal.full-screen-mobile', function() {
    $('body').addClass('full-screen-mobile');
});
$(document).on('hide.bs.modal', '.modal.full-screen-mobile', function() {
    $('body').removeClass('full-screen-mobile');
});

function isApp(){
    return typeof Trendier === "object";
}

function isAppSubdomain () {
    return document.body.classList.contains('is-app');
}

$(document).on('click', 'input[data-promo-change]', function() {
    this.dataset.promoChange.split(',').forEach(
        promo => Ajax.post(
            `/api/v5/promo/${promo}`,
            {
                'enabled' : this.checked? '1' : '',
                'source' : new URL( window.location.href ).pathname
            },
            false
        )
    );

    const parsedUrl = new URL( window.location.href );
    ;
});

if (isApp()) {
    $(document).on('click', '[data-call-app]', function(e){
        if (canCallApp(this.dataset.callApp)) {
            e.preventDefault();
            e.stopImmediatePropagation(); 
            let methodParam = this.dataset.callAppParam;
            if ('undefined' === typeof methodParam) {
                Trendier[this.dataset.callApp]();
                return;
            }

            Trendier[this.dataset.callApp](methodParam);
        }
    });
}

let user = config.user ? config.user : null;
if(user){

    user.registerDate = new Date(user.registerDate * 1000);

    if(canCallApp("setNotificationCount")){
        Trendier.setNotificationCount(user.notifications);
    }
}

onLoad(() => {
    // Puerta de los anónimos en las plantillas. La clase marca dos cosas distintas: enlaces que
    // ya apuntan a /login o /sign-up (cabecera, perfil de influencer, home, "quiénes somos") y
    // botones de acción que exigen sesión ("Hacer oferta", "Comprar ahora", añadir al carrito).
    // Hay que mirar el href de cada uno: si no, el botón "Registrarse" del perfil de influencer
    // acabaría en el login en vez de en el registro (GOT-16956).
    if(!isLogged()){
        document.querySelectorAll('.js-signup-button').forEach(el => {
            el.addEventListener('click', e => {
                const href = el.getAttribute('href');

                if (redirectAnonymous(href === '/sign-up' ? '/sign-up' : '/login')){
                    e.preventDefault();
                    e.stopPropagation();
                }
            });
        });
    }

    /* Dejar visible solo la parte que usuario anonimo/logueado */
    if(user){
        if(user.img){
            $('.js-self-avatar').attr('src', user.img);
        }

        // check if article is pending payment grid
        document.querySelectorAll('.alert-not-available[data-uids]').forEach((el) => {
            if (el != null && el.dataset.uids.includes(user.id.toString())) {
                el.classList.add("alert-pending-payment");
                el.classList.remove("alert-not-available");

                const whiteDiv = el.querySelector('.text-white');

                if (whiteDiv != null) {
                    whiteDiv.innerText = el.dataset.pendingText;
                } else {
                    el.innerText = el.dataset.pendingText;
                }
            }
        });

        setBannerCloseButton();
        removeAlertOnLinkClick();
    }

    //
    // Abrir el menú de filtros de la app
    const appFiltersButton = document.querySelector('.filters-button');
    if (canCallApp('openFilters') && appFiltersButton) {
        appFiltersButton.classList.remove('d-none');
    }

    //
    // Dropup container open
    document.querySelectorAll('.js-open-dropup-container').forEach(btn =>
        btn.addEventListener('click', e => {
            e.preventDefault();
            const containerTarget = document.querySelector(btn.dataset.target);
            if (containerTarget) {
                containerTarget.classList.add('dropup-active');
            }
        })
    );

    //
    // Dropup container close
    document.querySelectorAll('.js-close-dropup-container').forEach(btn => btn.addEventListener('click', e => {
        e.preventDefault();
        if (btn.closest('.dropup-active')) {
            btn.closest('.dropup-active').classList.remove('dropup-active');
        }
    }));

    // Menú usuario
    const userMenuOverlay = document.querySelector('.user-menu-overlay'),
        userMenuBtns = document.querySelectorAll('.js-user-menu-toggle'),
        userMenu = document.querySelector('.user-menu'),
        notificationContainer = document.querySelector('.notification-container');

    userMenuBtns.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            if (userMenu) {
                if (userMenu.classList.contains('show')) {
                    userMenu.classList.remove('show');
                    document.querySelectorAll('html, body').forEach(elem => elem.classList.remove('overflow-hidden'));
                } else {
                    userMenu.classList.add('show');
                    document.querySelectorAll('html, body').forEach(elem => elem.classList.add('overflow-hidden'));
                }
                if (notificationContainer) {
                    notificationContainer.classList.remove('show');
                }
            }
        });
    });
    if (userMenuOverlay) {
        userMenuOverlay.addEventListener('click', e => {
            userMenu.classList.remove('show');
            document.querySelectorAll('html, body').forEach(elem => elem.classList.remove('overflow-hidden'));
        });
    }

    if ( !isApp() ) {
        hideCookiesBanner();
    }

    hideFullPageLoader();
});

// Hasta WEB-153, /login y /sign-up los servía el legacy y aquí se abría un modal con su propio
// formulario. Ahora esas dos rutas las sirve Next, y el POST del modal iba contra una ruta que ya
// no era suya: Next respondía con su página, no se autenticaba a nadie y el usuario acababa en una
// pantalla de login sin sesión y sin ningún error (GOT-16956).
//
// Así que en lugar de abrir un modal se navega a la página de verdad, llevando en `redirect_to`
// dónde estaba el usuario para devolverlo ahí una vez identificado.
//
// Se manda la ruta relativa y no la URL absoluta por dos motivos. Uno, el origen no aporta nada:
// siempre es el nuestro, y tanto el legacy (Login.php::getRedirectTo) como Next aceptan una ruta
// relativa. Y dos, ocupa menos, que aquí importa — ver abajo.
//
// En producción /login y /sign-up los sigue sirviendo el legacy, y ahí `redirect_to` es un campo
// oculto validado con max_length[200] (Login.php). Si nos pasamos de largo, su validación falla al
// enviar el formulario y la persona NO PUEDE ENTRAR. Con un permalink largo es alcanzable. Así que
// si no cabe, se va al login sin destino: se pierde la vuelta a la página de origen —que es
// exactamente lo que pasaba antes de este cambio— pero nadie se queda fuera.
//
// Se mide en bytes y no en caracteres porque CodeIgniter cuenta con mb_strlen o con strlen según
// cómo esté configurado, y una ruta con acentos (una búsqueda, por ejemplo) ocupa más bytes que
// caracteres. Midiendo bytes nos quedamos con la cuenta más alta de las dos, que es el lado
// seguro: como mucho perdemos el destino, nunca dejamos a nadie sin poder entrar.
const REDIRECT_TO_MAX_LENGTH = 200;

const goToAuthPage = (path = '/login') => {
    const target = window.location.pathname + window.location.search;
    const targetLength = new TextEncoder().encode(target).length;

    window.location.href = targetLength > REDIRECT_TO_MAX_LENGTH
        ? path
        : `${path}?redirect_to=${encodeURIComponent(target)}`;
};

const isLogged = () => {
    return (user !== null);
};


// Devuelve true si ha tomado el control (el usuario es anónimo), para que quien la llama cancele
// la acción que se estaba intentando. `path` es a dónde mandarlo: por defecto al login, pero los
// puntos de entrada que son de registro le pasan '/sign-up'. Antes era un booleano que
// `showLoginSignupModal` ni siquiera miraba, y nadie lo usaba.
const redirectAnonymous = (path = '/login') => {
    if (isLogged()) {
        return false;
    }

    if (isApp()) {
        window.location.href = '/app/auth';
    } else {
        goToAuthPage(path);
    }

    return true;
};

//
// COPY TO CLIPBOARD
$(document).on('click', '[data-clipboard]', function(e){
    e.preventDefault();
    if(canCallApp('clipboard')) {
        Trendier.clipboard(this.dataset.clipboard);
    } else {
        let temp = document.createElement('input');
        document.body.appendChild(temp);
        temp.value = this.dataset.clipboard;
        temp.style.display = 'absolute';
        temp.style.left = '-99999px';
        temp.select();
        document.execCommand("copy");
        temp.remove();
    }
});

//
// Meter en el DOM, abrir, cerrar y eliminar modals definidos dentro de templates
function showModalFromTemplate(templateSelector, onShow)
{
    const template = document.querySelector(templateSelector),
        content = document.importNode(template.content, true),
        modal = document.body.appendChild(content.querySelector('.modal'));
    $(modal).modal();

    if (typeof onShow !== "undefined") {
        $(modal).on('shown.bs.modal', onShow);
    }

    $(modal).on('hidden.bs.modal', () => $(modal).remove());
}

document.querySelectorAll('[data-toggle="modal"][data-target]').forEach((el) => { // Para los modals abiertos desde data attributes
    el.addEventListener('click', (e) => {
        const modalId = e.target.dataset.target,
            templateSelector = modalId + '-template';
        if (document.querySelector(templateSelector) !== null) {
            e.preventDefault();
            e.stopPropagation();
            showModalFromTemplate(templateSelector);
        }
    });
});

function updateFlow() {
    const urlParams = new URLSearchParams(window.location.search);
    const currentFlow = urlParams.get('flow') ?? config.flow;
    if (currentFlow != null) {
        safeLocalStorage.setItem('latestUserFlow', currentFlow);
    }
}

function reloadWithQueryParameters(queryString) {
    return location.protocol + '//' + location.host + location.pathname + queryString;
}

// Remove value from array
const arrayRemove = (arr, value) => arr.filter((item) => item !== value);

const removeFadeOut = (el, speed) => {
    const seconds = speed/1000;
    el.style.transition = `opacity ${seconds}s ease`;
    el.style.opacity = 0;
    setTimeout(() => el.remove(), speed);
}

updateFlow();

const boldCitations = function(comment) {
    let ocurrences = 0;  ;
    return comment.replaceAll(new RegExp(config.citations_regex, 'g'), (x) => ocurrences++ < config.max_citations_per_comment? `<b>${x}</b>` : x);
}

const scrollToElement = (element, headerOffset = 100) =>  {
    const offsetPosition = element.offsetTop - headerOffset;
    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
    });
};

function getFlow () {
    return safeLocalStorage.getItem('latestUserFlow');
};

export {
    defaultAlertModal,
    defaultConfirmModal,
    config,
    mobileBreakPoint,
    isApp,
    isAppSubdomain,
    btnLoading,
    canCallApp,
    user,
    isLogged,
    showModalFromTemplate,
    redirectAnonymous,
    goToAuthPage,
    inArray,
    reloadWithQueryParameters,
    arrayRemove,
    removeFadeOut,
    boldCitations,
    scrollToElement,
    TYPINGDELAY,
    getFlow,
    debounce
};
